module.exports = __webpack_public_path__ + "static/media/swotIcon.9eed7fa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swotIcon.png
// module id = 76
// module chunks = 0